import { axiosApiInstance } from './axios';

// -------------------------------------------------------------

const apiRoot = '';

const pageIndicatorsApi = {
  get: async (params) => {
    try {
      const res = await axiosApiInstance.get(`${apiRoot}/web/page-indicators/v1/get-all`, {
        params,
      });

      return res;
    } catch (e: any) {
      return e.response;
    }
  },
};

export default pageIndicatorsApi;
